<template>
  <div class="online">
    <div class="head">
      <span class="name">{{ deptName }}</span>
      <ul class="tabs">
        <li
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ current: item.value == current }"
          @click="onItemClick(item)"
        >
          {{ item.key }}
          <el-divider
            v-if="index !== tabs.length - 1"
            direction="vertical"
          ></el-divider>
        </li>
      </ul>
    </div>
    <ul class="list">
      <li @click="onDetail(item)" v-for="item in askList" :key="item.id">
        <div class="content">
          <div class="title">
            <div class="tag">问</div>
            <span class="txt">{{ item.title }}</span>
          </div>
          <div class="desc">
            {{ item.describe | formatText }}
          </div>
          <div class="next">
            <div class="lt">
              <span>{{ item.userName }}</span>
              <span>对</span>
              <span>{{ item.deptName }}</span>
              <span>说</span>
            </div>
            <div class="rt">{{ item.handelTime }}</div>
          </div>
        </div>
        <el-image
          v-if="item.status >= 20"
          class="pos__icon"
          :src="require('images/online/reply.png')"
        ></el-image>
        <el-image
          v-if="item.status == 10"
          class="pos__icon"
          :src="require('images/online/accept.png')"
        ></el-image>
        <el-image
          v-if="item.status == 1 || item.status == 6"
          class="pos__icon"
          :src="require('images/online/reject.png')"
        ></el-image>
      </li>
    </ul>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="currentSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getAskList } from "@/api/wzasksevent";
import { htmlToText } from "@/utils/tools";
export default {
  name: "online",
  computed: {
    deptId() {
      return this.$route.params.id;
    },
    deptName() {
      return this.$route.params.name;
    },
    // currentPage() {
    //   return Number(this.$route.params.page);
    // },
    // current() {
    //   return this.$route.params.type;
    // },
  },
  data() {
    return {
      current: "",
      tabs: [
        {
          key: "全部",
          value: "",
        },
        {
          key: "未受理",
          value: 1,
        },
        {
          key: "已受理",
          value: 10,
        },
        {
          key: "已答复",
          value: 20,
        },
      ],
      currentPage: 1,
      currentSize: 10,
      total: 0,
      askList: [],
    };
  },
  filters: {
    formatText(val) {
      return htmlToText(val);
    },
  },
  watch: {
    $route: {
      handler(val) {
        // console.log(val)
        const { page, type } = val.params;
        console.log(page);
        console.log(type);
        this.currentPage = parseInt(page);
        if (type === "null") {
          this.current = "";
        } else {
          this.current = parseInt(type);
        }
        this.getAskList();
      },
      immediate: true,
    },
  },
  mounted() {
    this.getAskList();
  },
  methods: {
    async getAskList() {
      const res = await getAskList(this.currentPage, this.currentSize, {
        status: this.current,
        deptId: this.deptId,
        descs: "create_time",
      });
      // console.log(res);
      this.askList = res.data.records;
      this.total = res.data.total;
    },
    onDetail(item) {
      this.$router.push({
        path:"/web/detail/",
        query:{
          id:item.id,
          page:1,
          type:1
        }
      });
    },
    onItemClick(item) {
      if (this.current == item.value) return;
      if (item.value === "") {
        this.$router.push(
          `/web/deptlist/${this.deptId}/${this.deptName}/1/null`
        );
      } else {
        this.$router.push(
          `/web/deptlist/${this.deptId}/${this.deptName}/1/${item.value}`
        );
      }

      // this.currentPage = 1;
      // this.current = item.value;
      // this.getAskList();
    },
    handleSizeChange(val) {
      this.currentSize = val;
      this.getAskList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAskList();
    },
  },
};
</script>

<style lang="scss" scoped>
.online {
  background: #ffffff;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 68px;
    padding: 0 20px;
    .name {
      font-size: 18px;
      font-weight: 700;
      color: #2a2b2e;
    }
    .tabs {
      display: flex;
      li {
        font-size: 16px;
        color: #90949e;
        &.current {
          font-weight: 700;
          color: #2a2b2e;
        }
      }
    }
  }
  .list {
    li {
      box-shadow: 0px -1px 0px 0px #f0f2f5 inset;
      position: relative;
      .content {
        padding: 20px;
        .title {
          display: flex;
          align-items: center;
          .tag {
            font-size: 13px;
            color: #5cbd31;
            padding: 5px;
            border-radius: 5px;
            border: 1px solid #5cbd31;
          }
          .txt {
            font-size: 18px;
            color: #333333;
            font-weight: 700;
            margin-left: 8px;
          }
        }
        .desc {
          font-size: 14px;
          color: #999999;
          line-height: 26px;
          margin-top: 14px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .next {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 15px;
          .lt {
            font-size: 14px;
            span:nth-child(odd) {
              color: #52545b;
            }
            span:nth-child(even) {
              color: #999999;
              padding: 0 14px;
            }
          }
          .rt {
            font-size: 13px;
            color: #999999;
          }
        }
      }
      .pos__icon {
        width: 68px;
        position: absolute;
        right: 20px;
        top: 20px;
      }
    }
  }
  .el-pagination {
    padding: 20px;
  }
}
</style>
